// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2VNQE","inputs":"styles_inputs__2vDxG","withCheckbox":"styles_withCheckbox__1dySH"};